// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"194":"gatsby-plugin-image","774":"framework"}[chunkId] || chunkId) + "-" + {"194":"56e87274d5670d72ec0d","217":"fbfe31c7fca67a6f5cf0","231":"7268826953a285666a9c","774":"9edc7df713b0aca71de5"}[chunkId] + ".js";
};